<template>
  <el-container>
    <!-- 上传对话框 -->
    <el-dialog
      title="导入舆情列表"
      :visible.sync="upload.dialogFormVisible"
      :width="upload.dialogWidth"
    >
      <el-card class="box-card">
        <el-upload
          ref="importupload"
          class="upload-demo"
          drag
          action=""
          :multiple="false"
          :auto-upload="false"
          accept=".xls, .xlsx"
          :file-list="upload.importFileList"
          :on-remove="fileRemove"
          :on-success="uploadSuccess"
          :on-change="importOnChange"
          :before-upload="beforeUpload"
          :limit="1"
          :http-request="httpRequest"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          <div class="el-upload__tip" slot="tip">
            只能上传上级舆情系统导出的Excel文件(.xls,.xlsx),且不超过5M
          </div>
        </el-upload>
      </el-card>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="excelImportPst">开始导入</el-button>
        <el-button @click="upload.dialogFormVisible = false">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 主体内容 -->
    <el-header
      style="display: flex; align-items: center; justify-content: space-between"
    >
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>待转办工单列表</el-breadcrumb-item>
      </el-breadcrumb>
      <el-button-group>
        <!-- <el-button
          type="info"
          icon="el-icon-magic-stick"
          @click.native="netMessage"
          >手工录入</el-button
        > -->
        <el-button
          type="info"
          icon="el-icon-upload2"
          @click.native="uploadDlgShow"
          >Excel文件导入</el-button
        ></el-button-group
      >
    </el-header>
    <el-main>
      <div>
        <!-- 查询工具栏-->
        <div class="mb-3 cust_seach">
          <el-input
            class="btnTitle"
            v-model="query.queryString"
            placeholder="请输入模糊字段"
          />
          <el-button-group>
            <el-button
              type="primary"
              icon="el-icon-search"
              @click="querySubmit"
            />
          </el-button-group>
        </div>
        <el-table :data="data.psts">
          <el-table-column prop="postingTime" label="发贴时间" width="100">
            <template slot-scope="scope">
              <div>
                {{ Common.dateFormatter(scope.row.postingTime, "yyyy-MM-dd") }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="发贴人" width="150" />
          <el-table-column prop="title" label="标题">
            <template slot-scope="scope">
              <div>
                <el-button
                  type="text"
                  size="small"
                  @click="detail(scope.row.id)"
                >
                  {{ scope.row.title }}
                </el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="pstSource" label="舆情来源" width="120">
            <template slot-scope="scope">
              <div>
                <a :href="scope.row.pstUrl" target="_blank">{{
                  scope.row.pstSource
                }}</a>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="lastTime" label="审查时间" width="150">
            <template slot-scope="scope">
              <span>
                {{
                  Common.dateFormatter(scope.row.lastTime, "yyyy-MM-dd hh:mm")
                }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="状态" width="80">
            <template slot-scope="scope">
              <el-tag
                :type="
                  scope.row.status === 6 || scope.row.status === -1
                    ? 'info'
                    : 'success'
                "
                disable-transitions
                >{{ pstApi.getStatusTransferTitle(scope.row.status) }}</el-tag
              >
            </template>
          </el-table-column>
          <el-table-column prop="status" width="60" fixed="right" label="操作">
            <template slot-scope="scope">
              <!-- <el-button type="text" size="small"> 转办 </el-button> -->
              <el-button
                v-if="scope.row.status == 0 || scope.row.status == 3"
                @click="transfer(scope.row.id)"
                type="text"
                size="small"
              >
                转办
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="cust_pagin">
          <el-pagination
            layout="prev, pager, next"
            :total="xpagination.totalCount"
            :page-size="xpagination.pageSize"
            :current-page="xpagination.pageNumber"
            @current-change="handleCurrentChange"
            hide-on-single-page
            :background="true"
          />
        </div>
      </div>
    </el-main>
  </el-container>
</template>
    
<script>
export default {
  created() {
    //this.getUnits(); //读取所有单位信息
    this.getPstList(); //读取分页信息
  },
  data() {
    return {
      //数据项
      data: {
        psts: [], //舆情信息
      },
      //搜索栏数据
      query: {
        unitId: "00000000-0000-0000-0000-000000000000", //单位信息
        pstType: -1, //类别
        category: 0, //状态
        queryString: "", //模糊字段
      },
      //分页栏数据
      xpagination: {
        totalCount: 1,
        pageSize: 10,
        pageNumber: 1,
        totalPages: 1,
      },
      //上传对话框
      upload: {
        dialogFormVisible: false,
        dialogWidth: this.ISMOBILE ? "100%" : "500px",
        importFileList: [],
      },
    };
  },
  methods: {
    //查询方法部分
    //////////////////////////////////////////////////////////////////////////////////////////
    querySubmit() {
      this.getPstList();
    },
    getPstList() {
      this.pstApi
        .getNewPstList(
          this.query.queryString,
          this.xpagination.pageNumber,
          this.xpagination.pageSize
        )
        .then((res) => {
          var data = res.data;
          this.data.psts = data;
          var pagin = JSON.parse(res.headers.xpagination);
          this.xpagination.totalCount = parseInt(pagin.totalCount);
          this.xpagination.pageSize = parseInt(pagin.pageSize);
          this.xpagination.pageNumber = parseInt(pagin.currentPage);
          this.xpagination.totalPages = parseInt(pagin.totalPages);
        })
        .catch(() => {
          Toast("读取失败");
        });
    },
    //分页操作
    handleCurrentChange(val) {
      this.xpagination.pageNumber = val;
      this.getPstList();
    },
    transfer(id) {
      this.$router.push({ name: "Transfer", params: { id: id } });
    },
    detail(pstId) {
      this.$router.push({ name: "Details", params: { id: pstId } });
    },
    netMessage() {
      this.$router.push({ name: "NetMessage" });
    },
    //导入对话框方法部分
    //==================================
    excelImportPst() {
      if (this.upload.importFileList.length <= 0) {
        this.$message.error("请选择上传文件");
        return;
      }
      this.$refs.importupload.submit();
    },
    // 文件上传前的钩子，file为上传的文件
    beforeUpload(file) {
      //判断文件格式是否为xls,xlsx
      var ext = this.Common.getFileExtension(file.name).toLocaleUpperCase();
      if (ext != "XLS" && ext != "XLSX") {
        this.$toast("不支持该文件格式");
        return false;
      }
      // 判断图片是否大于2M
      const isLt5M = file.size / 1024 / 1024 < 5;
      // console.log(file.type);
      if (!isLt5M) {
        this.$toast("文件大小不能超过 5M!");
        return false;
      }
    },
    // 文件列表移除文件时的钩子
    fileRemove(file, fileList) {
      this.upload.importFileList = fileList;
    },
    importOnChange(file, fileList) {
      this.upload.importFileList = fileList;
    },
    uploadSuccess(resp) {},
    //开始上传
    httpRequest(params) {
      this.upload.dialogFormVisible = false;
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let fileObj = params.file; // 相当于input里取得的files
      let formData = new FormData(); // FormData 对象
      formData.append("File", fileObj); // 文件对象
      //调用api接口上传文件
      this.pstApi
        .pstImport(formData)
        .then((res) => {
          this.$toast(res.data.message);
          loading.close();
          this.getPstList();
        })
        .catch((err) => {
          var message = err.response.data.Message;
          if (message == null) {
            message = "服务器访问失败";
          }
          loading.close();
          this.$toast(message);
        });
    },
    uploadDlgShow() {
      this.upload.importFileList = [];
      this.upload.dialogFormVisible = true;
    },
    //=================================================
  },
};
</script>
    
  <style lang="less" scoped>
.el-header {
  background-color: #b3c0d1;
  color: #333;
  line-height: 40px;
}
//工具栏样式
.cust_seach {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;
  width: 100%;
  padding: auto 5px;
  .btnLeft {
    flex: 1;
    margin: 0;
    /deep/ .el-input__inner {
      height: 41px;
      border-radius: 0px;
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
    }
  }
  .btnTitle {
    flex: 2;
    margin: 0;
    /deep/ .el-input__inner {
      height: 41px;
      border-radius: 0px;
      border-top-left-radius: 0px;
      border-bottom-left-radius: 0px;
    }
  }
  .btnStatus {
    flex: 1;
    margin: 0;
    /deep/ .el-input__inner {
      height: 41px;
      border-radius: 0px;
      border-top-right-radius: 0px;
      border-bottom-right-radius: 0px;
    }
  }
  .el-button-group > .el-button:first-child:last-child {
    border-radius: 0px;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }
}
.el-select {
  float: left;
}
.cust_pagin {
  display: flex;
  position: sticky;
  bottom: 0;
  z-index: 999;
}
/deep/.el-breadcrumb__separator {
  color: rgb(87, 86, 86);
}
</style>